import * as TenantInstalmentEvent from './events-definition'
export { TenantInstalmentEvent }
